export enum ReportingEntityTypes {
    KeyWorkAreas = -1,
    DirectorateMilestones = -2,
    Metrics = -3,
    Commitments = -4,
    WorkStreams = -5,
    ProjectMilestones = -6,
    Benefits = -7,
    Dependencies = -8,
    PartnerOrganisationMilestones = -9,
    PartnerOrganisationRisks = -10,
    PartnerOrganisationRiskMitigatingActions = -11
}